export const shieldingState = {
    name: 'app.shielding',
    url: '/shielding',
    component: 'shielding'
};
